(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('noc-marquee')) {
    customElements.define('noc-marquee', class extends HTMLElement {
      connectedCallback() {
        if (!('IntersectionObserver' in window)) return;
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((e) => this.classList.toggle('is-paused', !e.isIntersecting));
        });
        this.io.observe(this);
      }
      disconnectedCallback() {
        if (this.io) this.io.disconnect();
      }
    });
  }

  /* 2026-10-17 patch 1 (g): rotate the offer slot of the dictionary line */
  if (!customElements.get('noc-rotator')) {
    customElements.define('noc-rotator', class extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.noc-define__item'));
        if (this.items.length < 2) return;
        this.index = Math.max(0, this.items.findIndex((el) => el.classList.contains('is-active')));
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.hold = 0;
        this.offscreen = false;
        const pause = () => { this.hold += 1; };
        const resume = () => { this.hold = Math.max(0, this.hold - 1); };
        this.addEventListener('mouseenter', pause);
        this.addEventListener('mouseleave', resume);
        this.addEventListener('focusin', pause);
        this.addEventListener('focusout', resume);
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => {
            entries.forEach((e) => { this.offscreen = !e.isIntersecting; });
          });
          this.io.observe(this);
        }
        /* theme editor: selecting a block shows it */
        document.addEventListener('shopify:block:select', this.onSelect = (e) => {
          const i = this.items.indexOf(e.target);
          if (i > -1) this.go(i);
        });
        const seconds = Math.min(15, Math.max(3, parseInt(this.dataset.seconds, 10) || 5));
        this.timer = setInterval(() => this.tick(), seconds * 1000);
      }
      tick() {
        if (this.reduce.matches || this.hold > 0 || this.offscreen || document.hidden) return;
        this.go((this.index + 1) % this.items.length);
      }
      go(i) {
        if (i === this.index || !this.items[i]) return;
        this.items[this.index].classList.remove('is-active');
        this.items[i].classList.add('is-active');
        this.index = i;
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        if (this.io) this.io.disconnect();
        if (this.onSelect) document.removeEventListener('shopify:block:select', this.onSelect);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('noc-mascot')) {
    customElements.define('noc-mascot', class extends HTMLElement {
      connectedCallback() {
        /* the plain ball replays on click; the framed print is a link */
        const ball = this.querySelector('.noc-mascot__ball');
        if (ball) ball.addEventListener('click', () => this.play());
        if (!('IntersectionObserver' in window)) { this.classList.add('is-in'); return; }
        this.io = new IntersectionObserver((entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            this.classList.add('is-in');
            this.io.disconnect();
          }
        }, { threshold: 0.4 });
        this.io.observe(this);
      }
      disconnectedCallback() { if (this.io) this.io.disconnect(); }
      play() {
        this.classList.remove('is-in');
        void this.offsetWidth;
        this.classList.add('is-in');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    if (window.__nocView) return;
    window.__nocView = true;
    const html = document.documentElement;
    const sync = () => {
      const dark = html.classList.contains('view-dark');
      document.querySelectorAll('[data-view-toggle]').forEach((b) => {
        b.setAttribute('aria-pressed', String(dark));
        b.setAttribute('aria-label', dark ? b.dataset.labelLight : b.dataset.labelDark);
      });
      const m = document.querySelector('meta[name="theme-color"]');
      if (m && m.dataset.light) m.content = dark ? m.dataset.dark : m.dataset.light;
    };
    document.addEventListener('click', (e) => {
      const b = e.target.closest && e.target.closest('[data-view-toggle]');
      if (!b) return;
      const next = html.classList.contains('view-dark') ? 'light' : 'dark';
      const apply = () => {
        html.classList.toggle('view-dark', next === 'dark');
        try { localStorage.setItem('nc-view', next); } catch (err) {}
        sync();
      };
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!document.startViewTransition || reduce) { apply(); return; }
      const r = b.getBoundingClientRect();
      const x = r.left + r.width / 2, y = r.top + r.height / 2;
      html.style.setProperty('--vt-x', x + 'px');
      html.style.setProperty('--vt-y', y + 'px');
      html.style.setProperty('--vt-r', Math.hypot(Math.max(x, innerWidth - x), Math.max(y, innerHeight - y)) + 'px');
      document.startViewTransition(apply);
    });
    document.addEventListener('DOMContentLoaded', sync);
    sync();
  })();

  if (!customElements.get('noc-menu')) {
    customElements.define('noc-menu', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.onOpen = (e) => {
          const btn = e.target.closest && e.target.closest('[data-menu-open]');
          if (!btn || btn.getAttribute('aria-controls') !== this.dialog.id) return;
          this.open(btn);
        };
        document.addEventListener('click', this.onOpen);
        this.dialog.addEventListener('click', (e) => {
          if (e.target.closest('[data-menu-close]')) { this.close(); return; }
          const a = e.target.closest('a[href]');
          if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
          const url = new URL(a.href, location.href);
          if (url.pathname === location.pathname && url.search === location.search && url.hash) this.close(false, true);
        });
        this.dialog.addEventListener('cancel', (e) => {
          e.preventDefault();
          this.close();
        });
        this.onShow = (e) => { if (e.persisted && this.dialog.open) this.close(false, true); };
        window.addEventListener('pageshow', this.onShow);
      }
      disconnectedCallback() {
        document.removeEventListener('click', this.onOpen);
        window.removeEventListener('pageshow', this.onShow);
        document.documentElement.classList.remove('menu-open');
      }
      open(btn) {
        if (this.dialog.open) return;
        this.opener = btn;
        const r = btn.getBoundingClientRect();
        this.dialog.style.setProperty('--menu-x', Math.round(r.left + 13) + 'px');
        this.dialog.style.setProperty('--menu-y', Math.round(r.top + r.height / 2) + 'px');
        this.dialog.showModal();
        document.documentElement.classList.add('menu-open');
        requestAnimationFrame(() => requestAnimationFrame(() => this.dialog.classList.add('is-open')));
      }
      close(keepFocus, instant) {
        if (!this.dialog.open) return;
        const done = () => {
          this.dialog.close();
          document.documentElement.classList.remove('menu-open');
          if (!keepFocus && this.opener) this.opener.focus();
        };
        this.dialog.classList.remove('is-open');
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce || instant) { done(); return; }
        let finished = false;
        const end = () => { if (finished) return; finished = true; done(); };
        this.dialog.addEventListener('transitionend', (e) => { if (e.target === this.dialog) end(); }, { once: true });
        setTimeout(end, 900);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  /* 2026-10-22 patch 2: the TV-flicker layers (dark room) get their files
     only after the page's load event, so they never compete with the room
     photo for the network. They stay lazy, so a hidden set still fetches
     nothing. Re-run when the theme editor re-renders the section. */
  (function () {
    if (window.__nocHeroTv) return;
    window.__nocHeroTv = true;
    const swap = () => {
      document.querySelectorAll('.noc-hero__tv[data-srcset]').forEach((img) => {
        const pic = img.parentElement;
        if (pic && pic.tagName === 'PICTURE') {
          pic.querySelectorAll('source[data-srcset]').forEach((s) => {
            s.srcset = s.dataset.srcset;
            s.removeAttribute('data-srcset');
          });
        }
        img.srcset = img.dataset.srcset;
        img.removeAttribute('data-srcset');
        if (img.dataset.src) {
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
        }
      });
    };
    if (document.readyState === 'complete') swap();
    else window.addEventListener('load', swap, { once: true });
    document.addEventListener('shopify:section:load', swap);
  })();

  /* the dark set's images are lazy (hidden, so never fetched in the light
     view): start them when someone reaches for the view toggle, so the
     switch doesn't show an empty room */
  (function () {
    if (window.__nocHeroWarm) return;
    window.__nocHeroWarm = true;
    const warm = (e) => {
      if (!e.target.closest || !e.target.closest('[data-view-toggle]')) return;
      document.querySelectorAll('.noc-hero__set img[loading="lazy"]').forEach((i) => { i.loading = 'eager'; });
    };
    ['pointerover', 'pointerdown', 'focusin'].forEach((t) => document.addEventListener(t, warm, { passive: true }));
  })();

  if (!customElements.get('noc-hero-glass')) {
    customElements.define('noc-hero-glass', class extends HTMLElement {
      connectedCallback() {
        this.hero = this.closest('.noc-hero');
        /* each view's set has its own photo, TV layers and glass */
        this.set = this.closest('.noc-hero__set') || this.hero;
        this.img = this.set && this.set.querySelector('.noc-hero__lounge:not(.noc-hero__tv)');
        this.tv = this.set && this.set.querySelector('.noc-hero__tv--1');
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        /* canvas units and the phone crop come from the set's data attributes:
           phone box = (wide box - (ox, oy)) * k */
        const d = this.dataset;
        const num = (v, f) => { const x = parseFloat(v); return isNaN(x) ? f : x; };
        this.wide = { iw: num(d.iw, 1638), ih: num(d.ih, 784), ox: 0, oy: 0, k: 1 };
        this.phone = { iw: num(d.phoneIw, 680), ih: num(d.phoneIh, 1274), ox: num(d.phoneOx, 720), oy: num(d.phoneOy, 0), k: num(d.phoneK, 1) };
        this.phoneSrc = d.phoneSrc || '';
        this.phoneMq = window.matchMedia('(max-width: 499px)');
        this.panes = Array.from(this.querySelectorAll('.noc-hero-glass__pane')).map((el, i) => ({
          el, i, box: el.dataset.box.split(',').map(Number), ghost: el.querySelector('[data-ghost]'),
          x: .5, y: .5, tx: .5, ty: .5, hv: 0, inn: false, gin: false, gA: 0, gx: 0, gy: 0, t0: 0, W: 0, H: 0
        }));
        if (!this.img || !this.panes.length) return;
        this.place = this.place.bind(this);
        /* resizes, and the set itself going from hidden to shown */
        this.ro = new ResizeObserver(() => this.place());
        this.ro.observe(this.hero);
        this.ro.observe(this.set);
        this.img.addEventListener('load', this.place);
        /* the header's view toggle flips html.view-dark */
        const html = document.documentElement;
        this.dark = html.classList.contains('view-dark');
        this.mo = new MutationObserver(() => {
          const dark = html.classList.contains('view-dark');
          if (dark !== this.dark) { this.dark = dark; this.place(); }
        });
        this.mo.observe(html, { attributes: true, attributeFilter: ['class'] });
        this.place();
        this.onMove = (e) => {
          for (const s of this.panes) {
            const r = s.el.getBoundingClientRect();
            const nx = (e.clientX - r.left) / r.width, ny = (e.clientY - r.top) / r.height;
            s.W = r.width; s.H = r.height;
            if (nx >= 0 && nx <= 1 && ny >= 0 && ny <= 1) {
              if (!s.inn) { s.inn = true; s.t0 = performance.now(); s.x = nx; s.y = ny; }
              s.tx = nx; s.ty = ny;
            } else s.inn = false;
          }
        };
        this.onLeave = () => { for (const s of this.panes) s.inn = false; };
        this.onUp = (e) => { if (e.pointerType === 'touch') this.onLeave(); };
        /* only animate while this set is on screen (a hidden set never intersects) */
        this.io = new IntersectionObserver((entries) => {
          if (entries.some((e) => e.isIntersecting)) this.start(); else this.stop();
        });
        this.io.observe(this);
      }
      disconnectedCallback() {
        this.stop();
        if (this.io) this.io.disconnect();
        if (this.ro) this.ro.disconnect();
        if (this.mo) this.mo.disconnect();
      }
      /* map each pane's box from canvas units to the photo as drawn
         (object-fit: cover at its object-position); phones get the crop */
      place() {
        const img = this.img;
        const W = img.clientWidth, H = img.clientHeight;
        if (!W || !H) return; /* the other view's set: placed when it shows */
        /* the photo actually shown; before a lazy photo loads, the same query its <source> uses */
        const src = img.currentSrc || '';
        const phone = src ? !!this.phoneSrc && src.indexOf(this.phoneSrc) !== -1 : this.phoneMq.matches;
        const c = phone ? this.phone : this.wide;
        const sc = Math.max(W / c.iw, H / c.ih);
        const pos = getComputedStyle(img).objectPosition.split(' ').map((v) => parseFloat(v) / 100);
        const offX = (W - c.iw * sc) * (isNaN(pos[0]) ? .5 : pos[0]);
        const offY = (H - c.ih * sc) * (isNaN(pos[1]) ? .5 : pos[1]);
        const k = c.k * sc;
        for (const s of this.panes) {
          const [x0, y0, x1, y1] = s.box;
          const st = s.el.style;
          st.left = (offX + (x0 - c.ox) * k).toFixed(1) + 'px';
          st.top = (offY + (y0 - c.oy) * k).toFixed(1) + 'px';
          st.width = ((x1 - x0) * k).toFixed(1) + 'px';
          st.height = ((y1 - y0) * k).toFixed(1) + 'px';
        }
        this.style.setProperty('--pane-k', k.toFixed(4));
        this.classList.add('is-placed');
      }
      start() {
        if (this.running) return;
        this.running = true;
        window.addEventListener('pointermove', this.onMove, { passive: true });
        window.addEventListener('pointerup', this.onUp);
        window.addEventListener('blur', this.onLeave);
        this.raf = requestAnimationFrame(this.tick);
      }
      stop() {
        if (!this.running) return;
        this.running = false;
        cancelAnimationFrame(this.raf);
        window.removeEventListener('pointermove', this.onMove);
        window.removeEventListener('pointerup', this.onUp);
        window.removeEventListener('blur', this.onLeave);
        this.onLeave();
      }
      tick = (now) => {
        if (!this.running) return;
        this.raf = requestAnimationFrame(this.tick);
        const t = now / 1000, depth = .32;
        /* the TV across the room shows in the glass: brighter on bright scenes
           (the light room has no TV, so a steady daylight sheen) */
        const tv = this.tv ? parseFloat(getComputedStyle(this.tv).opacity) || 0 : .4;
        const gs = .14 + tv * .18;
        for (const s of this.panes) {
          const W = s.W || s.el.offsetWidth, H = s.H || s.el.offsetHeight;
          s.x += (s.tx - s.x) * .16; s.y += (s.ty - s.y) * .16;
          s.hv += ((s.inn ? 1 : 0) - s.hv) * .1;
          const drift = this.reduce ? .5 : .5 + .5 * Math.sin(t * .4 + s.i * 2.1);
          const bp = drift * (1 - s.hv) + s.x * s.hv;
          let sw = -30;
          if (s.t0 && !this.reduce) { const q = (now - s.t0) / 1100; if (q >= 1) s.t0 = 0; else sw = Math.pow(1 - q, 3) * 100; }
          const st = s.el.style;
          st.setProperty('--gs', gs.toFixed(3));
          st.setProperty('--hv', s.hv.toFixed(3));
          st.setProperty('--bp', (bp * 100).toFixed(1) + '%');
          st.setProperty('--sw', sw.toFixed(1) + '%');
          st.setProperty('--mx', (s.x * 100).toFixed(1) + '%');
          st.setProperty('--my', (s.y * 100).toFixed(1) + '%');
          const px = s.x * W, py = s.y * H;
          const tx = px + (W / 2 - px) * depth, ty = py + (H / 2 - py) * depth;
          if (s.inn && !s.gin) { s.gx = tx; s.gy = ty; }
          s.gin = s.inn;
          s.gx += (tx - s.gx) * .3; s.gy += (ty - s.gy) * .3;
          s.gA += ((s.inn ? 1 : 0) - s.gA) * .16;
          s.ghost.style.transform = 'translate3d(' + s.gx.toFixed(1) + 'px,' + s.gy.toFixed(1) + 'px,0)';
          s.ghost.style.opacity = (s.gA * .9).toFixed(3);
        }
      };
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('noc-product-page')) {
    customElements.define('noc-product-page', class extends HTMLElement {
      connectedCallback() {
        this.views = Array.from(this.querySelectorAll('[data-view]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-view-to]'));
        this.index = 0;
        this.counter = this.querySelector('[data-view-index]');
        this.sizesView = this.views.findIndex((v) => v.querySelector('.noc-chart'));

        this.addEventListener('click', (e) => {
          const t = e.target.closest ? e.target : null;
          if (!t) return;
          const to = t.closest('[data-view-to]');
          if (to) {
            this.show(parseInt(to.dataset.viewTo, 10));
            /* 2026-10-17 patch 1 (a): on phones the thumbnails sit below Add
               to cart, so bring the picture back into view to show the change */
            if (this.phone && this.phone.matches) this.revealStage();
            return;
          }
          const step = t.closest('[data-view-step]');
          if (step) { this.show((this.index + parseInt(step.dataset.viewStep, 10) + this.views.length) % this.views.length); return; }
          if (t.closest('[data-size-guide]')) {
            if (this.sizesView > -1) this.show(this.sizesView);
            /* 2026-10-17 patch 1 (a): measure through galleryBox(), because under
               750px the gallery wrapper is display: contents and has no box */
            const g = this.galleryBox();
            if (g && g.getBoundingClientRect().top < 0) g.scrollIntoView({ behavior: this.motion(), block: 'start' });
            return;
          }
          const sheet = t.closest('[data-size-value]');
          if (sheet) { this.pickSize(sheet.dataset.sizeValue); return; }
          /* a frame pick shows on the print and both room views; from any
             other view, go to the print so the change is visible */
          if (t.closest('[data-nf]')) {
            if (!this.views[this.index].hasAttribute('data-follows-frame')) this.show(0);
            /* 2026-10-17 patch 1 (a): on phones "Try it in a frame" now sits
               below Add to cart, far from the picture; on the first pick, if
               the picture is mostly scrolled away, bring it back so the frame
               change shows. Later picks stay put so frames can be compared
               from the swatches: the On the wall and Detail thumbnails just
               below them redraw with each frame. */
            if (this.phone && this.phone.matches && !this.revealedFrame) {
              this.revealedFrame = this.revealStage();
            }
          }
        });
        this.phone = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;

        /* 2026-10-22 patch 2 (patch 1's known limit): under 750px "Try it in
           a frame" and the thumbnails are shown after Add to cart (CSS order),
           but in the markup they came before the size pills, so the Tab key
           (and screen readers) jumped down to them and back up. On phones
           they now also move in the markup, to just after the buy form; from
           750px they go back to the gallery, where the desktop layout has
           them. Only these two blocks move. Their clicks are handled by
           delegation (the frame picker in layout/theme.liquid, the thumbnails
           in this element), so that logic is untouched, and the CSS order
           keeps what the page looks like exactly the same. */
        this.flow = [this.querySelector('.noc-tryframe'), this.querySelector('.noc-gallery__thumbs')].filter(Boolean);
        this.buyForm = this.querySelector('.noc-buy__form');
        if (this.phone && this.flow.length && this.buyForm && this.phone.addEventListener) {
          this.flowMarks = this.flow.map((el) => {
            const mark = document.createComment('noc-flow');
            el.parentNode.insertBefore(mark, el);
            return mark;
          });
          this.onFlow = () => this.reflow();
          this.phone.addEventListener('change', this.onFlow);
          this.reflow();
        }

        this.radios = Array.from(this.querySelectorAll('input[type="radio"][data-option]'));
        this.radios.forEach((r) => r.addEventListener('change', () => this.syncSize()));
        document.addEventListener('click', this.onFrame = (e) => {
          if (e.target.closest && e.target.closest('[data-nf]')) requestAnimationFrame(() => this.syncFrame());
        });
        this.syncSize();
        this.syncFrame();
      }
      disconnectedCallback() {
        document.removeEventListener('click', this.onFrame);
        if (this.onFlow) this.phone.removeEventListener('change', this.onFlow);
      }
      /* 2026-10-22 patch 2: markup order follows the phone layout (see above) */
      reflow() {
        const focused = document.activeElement;
        if (this.phone.matches) {
          let after = this.buyForm;
          this.flow.forEach((el) => {
            if (after.nextElementSibling !== el) after.after(el);
            after = el;
          });
        } else {
          this.flow.forEach((el, i) => {
            const mark = this.flowMarks[i];
            if (mark.nextSibling !== el) mark.after(el);
          });
        }
        if (focused && focused !== document.activeElement && this.contains(focused)) focused.focus({ preventScroll: true });
      }
      show(i) {
        if (i === this.index || !this.views[i]) return;
        this.views[this.index].hidden = true;
        const v = this.views[i];
        v.hidden = false;
        v.classList.remove('is-entering');
        void v.offsetWidth;
        v.classList.add('is-entering');
        this.thumbs.forEach((t) => t.setAttribute('aria-pressed', String(parseInt(t.dataset.viewTo, 10) === i)));
        this.index = i;
        if (this.counter) this.counter.textContent = String(i + 1).padStart(2, '0');
      }
      pickSize(value) {
        const r = this.radios.find((x) => x.value === value);
        if (r && !r.checked) {
          r.checked = true;
          r.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      syncSize() {
        const r = this.radios.find((x) => x.checked && x.dataset.dims !== undefined && x.closest('.noc-option--size'));
        const out = this.querySelector('[data-size-readout]');
        if (out) out.textContent = r ? r.dataset.dims : '';
        this.querySelectorAll('[data-size-value]').forEach((s) => s.setAttribute('aria-pressed', String(!!r && s.dataset.sizeValue === r.value)));
      }
      syncFrame() {
        const on = this.querySelector('[data-nf][aria-pressed="true"]');
        const out = this.querySelector('[data-frame-readout]');
        if (out) out.textContent = on ? on.dataset.label : '';
      }
      /* 2026-10-17 patch 1 (a) helpers */
      motion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      }
      galleryBox() {
        const g = this.querySelector('.noc-gallery');
        return g && g.getClientRects().length ? g : this.querySelector('.noc-gallery__stage');
      }
      /* returns true when it scrolled */
      revealStage() {
        const stage = this.querySelector('.noc-gallery__stage');
        if (!stage) return false;
        const r = stage.getBoundingClientRect();
        const masthead = document.querySelector('.masthead');
        const head = masthead ? Math.max(0, masthead.getBoundingClientRect().bottom) : 0;
        const seen = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, head);
        if (seen >= r.height * 0.4) return false;
        stage.scrollIntoView({ behavior: this.motion(), block: 'start' });
        return true;
      }
    });
  }

  /* 2026-10-17 patch 1 (b): phone sticky Add to cart bar. */
  if (!customElements.get('noc-sticky-buy')) {
    customElements.define('noc-sticky-buy', class extends HTMLElement {
      connectedCallback() {
        this.page = this.closest('[data-product]');
        this.btn = this.querySelector('[data-sticky-add]');
        this.main = this.page ? this.page.querySelector('[data-add]') : null;
        if (!this.page || !this.btn || !this.main || !window.matchMedia) return;
        this.cta = this.page.querySelector('.noc-buy__cta') || this.main;
        this.sizeOut = this.querySelector('[data-sticky-size]');
        this.phone = window.matchMedia('(max-width: 749px)');
        this.past = false;

        /* copy the main button: label (incl. price x quantity), disabled
           and sold-out all come from the existing variant code */
        this.mirror = () => {
          const label = this.main.textContent.trim();
          if (this.btn.textContent !== label) this.btn.textContent = label;
          this.btn.disabled = this.main.disabled;
          const r = this.page.querySelector('.noc-option--size input[type="radio"]:checked');
          const id = r && r.parentElement ? r.parentElement.querySelector('.noc-size__id') : null;
          if (this.sizeOut) this.sizeOut.textContent = id ? id.textContent.trim() : '';
        };
        this.mo = new MutationObserver(this.mirror);
        this.mo.observe(this.main, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
        this.page.addEventListener('change', this.onChange = () => this.mirror());
        this.mirror();

        /* Shown once Add to cart has scrolled up out of view (under the
           header if the header is on screen), not before it is reached.
           A scroll check rather than an IntersectionObserver: a jump straight
           past the button (a fling, an anchor, "Try it in a frame" bringing
           the picture back) must still flip the bar. One rect read per frame. */
        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.ticking = false;
            this.check();
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        this.phone.addEventListener('change', this.onScroll);
        this.check();
      }
      check() {
        if (!this.phone.matches) {
          this.past = false;
        } else {
          const head = document.querySelector('.masthead');
          const top = head ? Math.max(0, head.getBoundingClientRect().bottom) : 0;
          this.past = this.cta.getBoundingClientRect().bottom <= top;
        }
        this.classList.toggle('is-shown', this.past);
      }
      disconnectedCallback() {
        if (this.mo) this.mo.disconnect();
        if (this.onScroll) {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
          this.phone.removeEventListener('change', this.onScroll);
        }
        if (this.page && this.onChange) this.page.removeEventListener('change', this.onChange);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-pairs"] && !Shopify.designMode) return;
  try {
    
  /* 2026-10-17 patch 1 (e): the "Pair it" quick adds follow the size picked
     in the product form (and in "See it on your wall", which drives the same
     radios). Only the hidden variant id and the button label change. */
  (function () {
    if (window.__nocPairsBound) return;
    window.__nocPairsBound = true;

    function sizeCode(value) {
      var k = String(value).toLowerCase().replace(/×/g, 'x').replace(/\s+/g, '');
      if (k.indexOf('21x29.7') > -1) return 'A4';
      if (k.indexOf('29.7x42') > -1) return 'A3';
      if (k.indexOf('42x59.4') > -1) return 'A2';
      if (k.indexOf('59.4x84.1') > -1) return 'A1';
      return '';
    }

    function money(cents, fmt) {
      var parts = (cents / 100).toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var amount = parts.join('.');
      /* same formatting as assets/noctura.js; the store format is "$" + amount */
      return fmt ? fmt.replace(/\{\{\s*amount\s*\}\}/, amount) : '$' + amount;
    }

    function follow(size) {
      if (!size) return;
      document.querySelectorAll('[data-pairs]').forEach(function (section) {
        var fmt = section.getAttribute('data-money-format');
        var withSize = section.getAttribute('data-label-size') || '';
        section.querySelectorAll('.noc-pair__add').forEach(function (form) {
          var list;
          try { list = JSON.parse(form.querySelector('[data-pair-variants]').textContent); } catch (e) { return; }
          var v = null;
          for (var i = 0; i < list.length; i++) {
            if (list[i].available && list[i].size === size) { v = list[i]; break; }
          }
          if (!v) return; /* that size isn't available: keep what the button already says */
          var input = form.querySelector('[data-pair-id]');
          var btn = form.querySelector('[data-pair-btn]');
          if (!input || !btn) return;
          input.value = v.id;
          var lbl = btn.querySelector('[data-pair-label]') || btn;
          lbl.textContent = withSize.replace('[size]', v.size).replace('[price]', money(v.price, fmt));
        });
      });
    }

    function current() {
      var r = document.querySelector('[data-product] .noc-option--size input[type="radio"][data-option]:checked');
      return r ? sizeCode(r.value) : '';
    }

    document.addEventListener('change', function (e) {
      var r = e.target;
      if (!r || !r.matches || !r.checked || !r.matches('[data-product] .noc-option--size input[type="radio"][data-option]')) return;
      follow(sizeCode(r.value));
    });

    /* a reload can restore a different radio than the one Liquid rendered */
    function start() { follow(current()); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-scale"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('noc-scale')) {
    /* Camera zoom per size, from the wall-showcase spec (A4 2.2, A3 1.65,
       A2 1, A1 0.94), re-based so A1 is 1: the photo never shrinks and
       leaves an empty edge. Zoom only moves the view; sizes stay true. */
    const ZOOM = { A4: 2.2 / 0.94, A3: 1.65 / 0.94, A2: 1 / 0.94, A1: 1 };
    const AIM = { x: 0.5, y: 0.46 }; /* where a zoomed print sits in the view */
    customElements.define('noc-scale', class extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.noc-scale');
        this.opts = Array.from(this.section.querySelectorAll('.noc-seg__opt'));
        this.cam = this.querySelector('.noc-scale__cam');
        this.scene = this.querySelector('.noc-scale__scene');
        this.print = this.querySelector('.noc-print');
        this.zoomNote = this.querySelector('[data-scale-zoom]');
        try { this.geo = JSON.parse(this.dataset.geo); } catch (e) { this.geo = {}; }
        this.radios = () => Array.from(document.querySelectorAll('[data-product] input[type="radio"][data-option]'));
        this.opts.forEach((o) => o.addEventListener('click', () => {
          const r = this.radios().find((x) => x.value === o.dataset.sizeValue);
          if (r && !r.checked) {
            r.checked = true;
            r.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            this.apply(o);
          }
        }));
        this.onChange = (e) => {
          if (!e.target.matches || !e.target.matches('[data-product] input[type="radio"][data-option]')) return;
          const o = this.opts.find((x) => x.dataset.sizeValue === e.target.value);
          if (o) this.apply(o);
        };
        document.addEventListener('change', this.onChange);
        this.resize = new ResizeObserver(() => {
          if (!this.current) return;
          this.classList.remove('is-ready');
          this.frameCamera(this.current);
          requestAnimationFrame(() => this.classList.add('is-ready'));
        });
        this.resize.observe(this);
        const start = this.opts.find((o) => o.getAttribute('aria-pressed') === 'true') || this.opts[Math.min(1, this.opts.length - 1)];
        if (start) this.apply(start);
        requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-ready')));
      }
      disconnectedCallback() {
        document.removeEventListener('change', this.onChange);
        if (this.resize) this.resize.disconnect();
      }
      apply(o) {
        const id = o.dataset.id;
        const g = this.geo[id];
        if (g && this.print) {
          const [x, y, w, h, rim] = g;
          const s = this.print.style;
          s.setProperty('--x', x);
          s.setProperty('--y', y);
          s.setProperty('--w', w);
          s.setProperty('--h', h);
          s.setProperty('--rim', rim);
        }
        this.current = id;
        this.frameCamera(id);
        this.opts.forEach((p) => p.setAttribute('aria-pressed', String(p === o)));
        this.querySelector('[data-scale-id]').textContent = id;
        this.querySelector('[data-scale-dims]').textContent = o.dataset.dims;
        if (this.zoomNote) this.zoomNote.textContent = (ZOOM[id] || 1) > 1.1 ? this.dataset.zoomed : this.dataset.true;
      }
      /* scale the view about the print and keep the photo covering the stage */
      frameCamera(id) {
        const g = this.geo[id];
        const z = ZOOM[id] || 1;
        if (!g || !this.cam) return;
        const W = this.clientWidth;
        const H = this.clientHeight;
        const sw = this.scene.offsetWidth;
        const sh = this.scene.offsetHeight;
        /* centre of the print */
        const px = this.scene.offsetLeft + ((g[5] ?? g[0] + g[2] / 2) / 100) * sw;
        const py = ((g[6] ?? g[1] + g[3] / 2) / 100) * sh;
        const tx = Math.min(0, Math.max(W * (1 - z), W * AIM.x - z * px));
        const ty = Math.min(0, Math.max(H * (1 - z), H * AIM.y - z * py));
        this.cam.style.transform = `translate(${tx.toFixed(2)}px, ${ty.toFixed(2)}px) scale(${z.toFixed(4)})`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spine-selection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('noc-spine')) {
    customElements.define('noc-spine', class extends HTMLElement {
      connectedCallback() {
        this.panels = Array.from(this.querySelectorAll('.noc-spine__panel'));
        const set = (p) => this.panels.forEach((x) => x.classList.toggle('is-active', x === p));
        this.panels.forEach((p) => {
          p.addEventListener('pointerenter', (e) => { if (e.pointerType !== 'touch') set(p); });
          p.addEventListener('focus', () => set(p));
        });
        this.addEventListener('pointerleave', (e) => { if (e.pointerType !== 'touch') set(this.panels[0]); });
        this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) set(this.panels[0]); });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
